<div id="internships" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h1 class="title">Internships</h1>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College provides internship opportunities to students to gain hands-on industry experience
      and enhance their professional skills. These programmes are aligned with AICTE guidelines and industry
      requirements.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Internship Programme Documents</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-6">
        <a href="assets/pdf/academics/Undergraduate_Internship_Programme_SSJGC-2-files-merged.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Undergraduate Internship Programme – SSJGC
        </a>
      </div>
      <!-- <div class="col-md-6">
        <a href="assets/pdf/internships/AICTE-summer_internship_2026_circular.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>AICTE Summer Internship 2026 Circular
        </a>
      </div> -->
    </div>

  </div>
</div>